<template>
  <div>
    <ScoreStartList2 :row="row.start" :list="row.list" v-if="row.start.current_show_type == 1"></ScoreStartList2>

    <ScoreStartArmy2 :row="row.start" :list="row.list" :start="row.start.subject" v-if="row.start.current_show_type == 2"></ScoreStartArmy2>

    <ScoreStartRank2 :row="row.start" :list="row.list" :start="row.start.subject" v-if="row.start.current_show_type == 3"></ScoreStartRank2>


    <ScoreStartSubjectRank2 :row="row.start" :start="row.start.subject" :list="row.rank_list" v-if="row.start.current_show_type == 4"></ScoreStartSubjectRank2>
  </div>
</template>

<script>
import {Toast} from "vant";
import ScoreStartList2 from "@/components/score/ScoreStartList2.vue";
import ScoreStartArmy2 from "@/components/score/ScoreStartArmy2.vue";
import ScoreStartRank2 from "@/components/score/ScoreStartRank2.vue";
import ScoreStartSubjectRank2 from "@/components/score/ScoreStartSubjectRank2.vue";
export default {
  name: "ScoreShow",
  data: function () {
    return {
      row: {
        start: {
          current_show_type: 0,
        },
        list: [],
        rank_list: []
      }
    }
  },
  components: {
    ScoreStartList2, ScoreStartArmy2, ScoreStartSubjectRank2,ScoreStartRank2
  },
  filters: {},
  mounted() {
    let that = this;
    document.title="数据展示"
    that.fetch()
    // 换成轮询
    that.timer = setInterval(function () {
      that.fetch()
    }, 2000)
  },
  destroyed() {
    // 销毁监听
    // this.socket.close()
    clearInterval(this.timer)
  },
  methods: {
    fetch() {
      let that = this;
      that.$api.post('/api/dscore/scoreMachine', {
        saiqu: that.$route.query.saiqu,
        start_id: that.$route.query.start_id,
      }, (res) => {
        that.row = res.data;
      }, (res) => {
        if (res.code == 401 || res.code == 402) {
          if (window.isApp()) {
            rbLink({
              name: 'login', 'query': {}
            }, 'replace');
            return false;
          }
          that.loginShow = true
        } else {
          Toast(res.msg)
        }
      })
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// ScoreShow.vue?297a4723